import { useState, useEffect } from "react";
import { saveTripDetails } from "../Api/TripDetail";
import { Container, Form, Button, Row, Col, Accordion, AccordionItem, AccordionBody } from "react-bootstrap";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import Sample14 from "../Components/Logo";
import { getProjectDetails } from "../Api/ProjectMaster";
import { useAuth } from "../Context/AuthContext";

import "../Styling/Title.css";
import "../Styling/Accordion.css";
import "../Styling/SaveButton.css";

const TripDetail = () => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const [loading, setLoading] = useState(false);
  const [tripData, setTripData] = useState({
    TripName: "",
    PurposeofTravel: "",
    EmployeeID: "",
    Department: "",
    ManagersName: "",
    TripStartDate: "",
    TripEndDate: "",
    Project: "",
  });

  const [projects, setProjects] = useState([]);

  useEffect(() => {
    const fetchProjects = async () => {
      try {
        const response = await getProjectDetails();
        if (Array.isArray(response)) setProjects(response);
        else if (Array.isArray(response?.data)) setProjects(response.data);
        else setProjects([]);
      } catch (error) {
        console.error("Error fetching projects:", error);
        toast.error("Failed to load projects");
      }
    };
    fetchProjects();
  }, []);

  const handleChange = (e) => {
    setTripData({ ...tripData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const tripPayload = {
        ...tripData,
        createdBy: user?.userId?.toString() || null,
      };
      await saveTripDetails(tripPayload);
      toast.success("🦄 Trip Added Successfully");
      setTripData({
        TripName: "",
        PurposeofTravel: "",
        EmployeeID: "",
        Department: "",
        ManagersName: "",
        TripStartDate: "",
        TripEndDate: "",
        Project: "",
      });
      navigate("/viewTrip");
    } catch (error) {
      toast.error("🦄 Some Error Happened");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container asset-master-fields">

      <h2 className="fields-title">Trip Detail</h2>

      {loading && (
        <div className="loading-overlay">
          <Sample14 />
        </div>
      )}

      <Form onSubmit={handleSubmit} className="fields-form">

        <Accordion defaultActiveKey="0">
          <AccordionItem eventKey="0">
            <AccordionBody>

              <Row className="g-3">

                <Col xl={4} lg={4} md={6} sm={12}>
                  <Form.Group>
                    <Form.Label>Trip Name</Form.Label>
                    <Form.Control
                      type="text"
                      name="TripName"
                      value={tripData.TripName}
                      onChange={handleChange}
                      required
                    />
                  </Form.Group>
                </Col>

                <Col xl={4} lg={4} md={6} sm={12}>
                  <Form.Group>
                    <Form.Label>Purpose of Travel</Form.Label>
                    <Form.Control
                      type="text"
                      name="PurposeofTravel"
                      value={tripData.PurposeofTravel}
                      onChange={handleChange}
                      required
                    />
                  </Form.Group>
                </Col>

                <Col xl={4} lg={4} md={6} sm={12}>
                  <Form.Group>
                    <Form.Label>Project</Form.Label>
                    <Form.Select
                      name="Project"
                      value={tripData.Project}
                      onChange={handleChange}
                      required
                    >
                      <option value="">-- Select Project --</option>
                      {projects.map((project) => (
                        <option key={project.prozmaPrId} value={project.prozmaPrId}>
                          {project.prTitle}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>

                <Col xl={4} lg={4} md={6} sm={12}>
                  <Form.Group>
                    <Form.Label>Department</Form.Label>
                    <Form.Control
                      type="text"
                      name="Department"
                      value={tripData.Department}
                      onChange={handleChange}
                      required
                    />
                  </Form.Group>
                </Col>

                <Col xl={4} lg={4} md={6} sm={12}>
                  <Form.Group>
                    <Form.Label>Manager's Name</Form.Label>
                    <Form.Control
                      type="text"
                      name="ManagersName"
                      value={tripData.ManagersName}
                      onChange={handleChange}
                      required
                    />
                  </Form.Group>
                </Col>

                <Col xl={4} lg={4} md={6} sm={12}>
                  <Form.Group>
                    <Form.Label>Trip Start Date</Form.Label>
                    <Form.Control
                      type="date"
                      name="TripStartDate"
                      value={tripData.TripStartDate}
                      onChange={handleChange}
                      required
                    />
                  </Form.Group>
                </Col>

                <Col xl={4} lg={4} md={6} sm={12}>
                  <Form.Group>
                    <Form.Label>Trip End Date</Form.Label>
                    <Form.Control
                      type="date"
                      name="TripEndDate"
                      value={tripData.TripEndDate}
                      onChange={handleChange}
                      required
                    />
                  </Form.Group>
                </Col>

              </Row>

            </AccordionBody>
          </AccordionItem>
        </Accordion>

        <div className="d-flex justify-content-start mt-4">
          <Button
            type="submit"
            className="fields-submit"
            disabled={loading}
          >
            {loading ? "Saving..." : "Save Trip"}
          </Button>
        </div>

      </Form>

    </div>
  );
};

export default TripDetail;

// import { useState } from "react";
// import { saveTripDetails } from "../Api/TripDetail";
// import { Container, Form, Button, Row, Col } from "react-bootstrap";
// //import "../Styling/TripDetail.css";
// import { toast } from "react-toastify";
// import { useNavigate } from "react-router-dom";
// import Sample14 from "../Components/Logo"; // Import Sample 14 loader
// import { getProjectDetails } from "../Api/ProjectMaster";

// const TripDetail = () => {
//   const navigate = useNavigate();
//   const [loading, setLoading] = useState(false); // Loader State

//   const [tripData, setTripData] = useState({
//     TripName: "",
//     PurposeofTravel: "",
//     EmployeeID: "",
//     Department: "",
//     ManagersName: "",
//     TripStartDate: "",
//     TripEndDate: "",
//   });

//   const handleChange = (e) => {
//     setTripData({ ...tripData, [e.target.name]: e.target.value });
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setLoading(true); // Show Loader
//     try {
//       await saveTripDetails(tripData);
//       toast.success(`🦄 Trip Added Successfully`);
//       setTripData({
//         TripName: "",
//         PurposeofTravel: "",
//         EmployeeID: "",
//         Department: "",
//         ManagersName: "",
//         TripStartDate: "",
//         TripEndDate: "",
//       });
//       console.log(tripData);
//       navigate("/viewTrip");
//     } catch (error) {
//       toast.error(`🦄 Some Error Happened`);
//     } finally {
//       setLoading(false); // Hide Loader
//     }
//   };

//   return (
//     <>
//       <div className="main-content expand">
//         <Container fluid className="fields-container">
//           <h2 className="fields-title">Trip Detail</h2>

//           <Form onSubmit={handleSubmit} className="fields-form">
//             <Row>
//               <Col md={4}>
//                 <Form.Group className="mb-3">
//                   <Form.Label>
//                     Trip Name <span className="text-red">**</span>
//                   </Form.Label>
//                   <Form.Control
//                     type="text"
//                     name="TripName"
//                     value={tripData.TripName}
//                     onChange={handleChange}
//                     required
//                   />
//                 </Form.Group>
//               </Col>
//               <Col md={4}>
//                 <Form.Group className="mb-3">
//                   <Form.Label>
//                     Purpose of Travel <span className="text-red">**</span>
//                   </Form.Label>
//                   <Form.Control
//                     type="text"
//                     name="PurposeofTravel"
//                     value={tripData.PurposeofTravel}
//                     onChange={handleChange}
//                     required
//                   />
//                 </Form.Group>
//               </Col>
//               {/* <Col md={4}>
//                   <Form.Group className="mb-3">
//                     <Form.Label>Employee ID <span className="text-red">**</span></Form.Label>
//                     <Form.Control type="text" name="EmployeeID" value={tripData.EmployeeID} onChange={handleChange} required />
//                   </Form.Group>
//                 </Col> */}
//             </Row>

//             <Row>
//               <Col md={4}>
//                 <Form.Group className="mb-3">
//                   <Form.Label>
//                     Department <span className="text-red">**</span>
//                   </Form.Label>
//                   <Form.Control
//                     type="text"
//                     name="Department"
//                     value={tripData.Department}
//                     onChange={handleChange}
//                     required
//                   />
//                 </Form.Group>
//               </Col>
//               <Col md={4}>
//                 <Form.Group className="mb-3">
//                   <Form.Label>
//                     Manager's Name <span className="text-red">**</span>
//                   </Form.Label>
//                   <Form.Control
//                     type="text"
//                     name="ManagersName"
//                     value={tripData.ManagersName}
//                     onChange={handleChange}
//                     required
//                   />
//                 </Form.Group>
//               </Col>
//               <Col md={4}>
//                 <Form.Group className="mb-3">
//                   <Form.Label>
//                     Trip Start Date <span className="text-red">**</span>
//                   </Form.Label>
//                   <Form.Control
//                     type="date"
//                     name="TripStartDate"
//                     value={tripData.TripStartDate}
//                     onChange={handleChange}
//                     required
//                   />
//                 </Form.Group>
//               </Col>
//             </Row>

//             <Row>
//               <Col md={4}>
//                 <Form.Group className="mb-3">
//                   <Form.Label>
//                     Trip End Date <span className="text-red">**</span>
//                   </Form.Label>
//                   <Form.Control
//                     type="date"
//                     name="TripEndDate"
//                     value={tripData.TripEndDate}
//                     onChange={handleChange}
//                     required
//                   />
//                 </Form.Group>
//               </Col>
//             </Row>

//             <div className="fields-btn-container">
//               <Button variant="primary" type="submit" className="fields-submit">
//                 Save Trip
//               </Button>
//             </div>
//           </Form>
//         </Container>
//       </div>

//       {/* Loader Overlay with Sample 14 */}
//       {loading && (
//         <div className="loading-overlay">
//           <Sample14 />
//         </div>
//       )}
//     </>
//   );
// };

// export default TripDetail;
